import type { JSX } from 'react';
import { useEffect } from 'react';

import { Form, TextField } from '@change/ds-forms';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useNameStep } from './hooks/useNameStep';

export function NameStep(): JSX.Element {
	const {
		data: { firstName, lastName, firstNameError, lastNameError },
		actions: { trackStepView, setStepData, submitStep },
	} = useNameStep();

	const { translate } = useI18n();

	useEffect(() => {
		trackStepView();
	}, [trackStepView]);

	return (
		<div>
			<Form
				onSubmit={() => {
					void submitStep();
				}}
				data-testid="name-form"
				data-qa="name-form"
			>
				<div className="mb-4">
					<TextField
						id="firstName"
						type="text"
						name="firstName"
						data-testid="firstName"
						data-qa="firstName"
						size="large"
						label={translate('corgi.login_or_signup.common.labels.first_name')}
						onChange={(value) => setStepData({ firstName: value })}
						value={firstName}
						isInvalid={!!firstNameError}
						errorMessage={firstNameError}
					/>
				</div>
				<div className="mb-4">
					<TextField
						id="lastName"
						type="text"
						name="lastName"
						data-testid="lastName"
						data-qa="lastName"
						size="large"
						label={translate('corgi.login_or_signup.common.labels.last_name')}
						onChange={(value) => setStepData({ lastName: value })}
						value={lastName}
						isInvalid={!!lastNameError}
						errorMessage={lastNameError}
					/>
				</div>
				{/* to handle submission by pressing enter */}
				<input type="submit" className="hidden" />
			</Form>
		</div>
	);
}
